import React, { useContext, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import Container from '@material-ui/core/Container';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import { Dropdown } from 'primereact/dropdown';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Link } from 'react-router-dom';
import { EnvContext } from '../Context/EnvProvider';
import { useAuth0 } from '@auth0/auth0-react';
import { isAdminUser } from '../../constants';
import {
  ENV_KEYS,
  environmentOptions,
  isProdEnvironmentKey,
} from '../../environments';

// Re-export for callers that still import from NavBar
export { environmentOptions };

const pages = [
  { path: 'ListBotTemplates', title: 'Lista de Templates', adminOnly: false },
  { path: 'ListBots', title: 'Lista de Bots', adminOnly: false },
  { path: 'CampaignMessages', title: 'Mensagens das Campanhas', adminOnly: true },
];

const NavBar = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const { environmentKey, setEnvironmentKey } = useContext(EnvContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [pendingEnvironmentKey, setPendingEnvironmentKey] = useState(null);
  const open = Boolean(anchorEl);
  const { user, isAuthenticated, logout } = useAuth0();
  const admin = isAdminUser(user?.email);

  const visiblePages = pages.filter((page) => !page.adminOnly || admin);

  const handleEnvironmentChange = (nextKey) => {
    if (isProdEnvironmentKey(nextKey) && !isProdEnvironmentKey(environmentKey)) {
      setPendingEnvironmentKey(nextKey);
      return;
    }
    setEnvironmentKey(nextKey);
  };

  const logoutWithRedirect = () =>
    logout({
      returnTo: window.location.origin,
    });

  return (
    <AppBar position="static" style={{ background: '#111827' }}>
      <ConfirmDialog
        visible={Boolean(pendingEnvironmentKey)}
        onHide={() => setPendingEnvironmentKey(null)}
        message="Você está prestes a apontar o admin para PRODUÇÃO. Continuar?"
        header="Confirmar ambiente Prod"
        icon="pi pi-exclamation-triangle"
        acceptLabel="Sim, usar Prod"
        rejectLabel="Cancelar"
        accept={() => {
          setEnvironmentKey(pendingEnvironmentKey || ENV_KEYS.PROD);
          setPendingEnvironmentKey(null);
        }}
        reject={() => setPendingEnvironmentKey(null)}
      />
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={(event) => setAnchorElNav(event.currentTarget)}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              open={Boolean(anchorElNav)}
              onClose={() => setAnchorElNav(null)}
            >
              {visiblePages.map((page) => (
                <MenuItem key={page.title} onClick={() => setAnchorElNav(null)}>
                  <Link to={page.path} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography>{page.title}</Typography>
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', sm: 'none', md: 'flex' },
              ml: 5,
              mx: 'auto',
              width: '140px',
              '& img': { width: '100%' },
            }}
          >
            <img src="./Lifty-Logo.png" alt="Logo" />
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {visiblePages.map((page) => (
              <Link
                key={page.title}
                to={page.path}
                style={{ marginRight: '30px', textDecoration: 'none', color: 'inherit' }}
              >
                <Typography>{page.title}</Typography>
              </Link>
            ))}
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'right' }}>
            <Dropdown
              value={environmentKey}
              options={environmentOptions}
              optionLabel="label"
              optionValue="key"
              placeholder="Ambiente"
              onChange={(e) => handleEnvironmentChange(e.value)}
              style={{ minWidth: 110 }}
            />
          </Box>
          {isAuthenticated && (
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'right' }}>
              <IconButton
                onClick={(event) => setAnchorEl(event.currentTarget)}
                size="small"
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
              >
                <Avatar sx={{ width: 50, height: 50 }}>
                  <img
                    src={user.picture}
                    alt="Profile"
                    className="nav-user-profile rounded-circle"
                    width="50"
                  />
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={() => setAnchorEl(null)}
                onClick={() => setAnchorEl(null)}
              >
                <MenuItem onClick={() => logoutWithRedirect()}>Log out</MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavBar;
